import { ReportType } from '@/models/report.model'

export function parseTime (timeStr: string): { hours: number; minutes: number } {
  const [hours, minutes] = timeStr.split(':').map(Number)
  return { hours, minutes }
}

export function getWeekNumber (d: Date): number {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()))
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7))
  // Get first day of year
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
  // Calculate full weeks to nearest Thursday
  const weekNo = Math.ceil(
    ((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7
  )
  // Return array of year and week number
  return weekNo
}

export function getValidReportType (type: string): ReportType | null {
  const normalizedType = type.toUpperCase()
  for (const enumKey of Object.keys(ReportType)) {
    if (isNaN(Number(enumKey))) {
      if (enumKey === normalizedType) {
        return ReportType[enumKey as keyof typeof ReportType]
      }
    }
  }
  return null
}

export function formatDateToString (date: Date): string {
  const options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  }
  if (!date) {
    return ''
  }

  if (date instanceof Date) {
    const formattedDate = date.toLocaleDateString('da-DK', options)
    console.log(formattedDate)
    return formattedDate
  }

  return new Date(date).toLocaleDateString('da-DK', options)
}

function pad (num: number): string {
  return num < 10 ? '0' + num : num.toString()
}

export function toJSONDate (date: Date | string) {
  // ensure JS date:
  if (!(date instanceof Date)) {
    date = new Date(date)
  }

  const danishDate =
    date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate())

  return danishDate
}
